import React, { useState } from 'react';
import MonthlyChart from '../../components/monthly-chart';

const AllTopupTransactionsChart = (): JSX.Element => {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  function increment() {
    setCurrentYear(currentYear - 1);
  }

  function decrement() {
    setCurrentYear(currentYear + 1);
  }

  return (
    <>
      <MonthlyChart
        label="(Rs.) total wallet loads"
        url={`/stats/wallet-loads/monthly-total/year/${currentYear}`}
        currentYear={currentYear}
        type="Area"
        stroke="#2fa35b"
        fill="#2fa35b"
      >
        <h4 className="section-title">
          <button className="btn btn-light" onClick={increment}>
            <i className="fas fa-chevron-left"></i>
          </button>
          &nbsp;
          {currentYear}
          &nbsp;
          <button className="btn btn-light" onClick={decrement}>
            <i className="fas fa-chevron-right"></i>
          </button>
        </h4>
      </MonthlyChart>
    </>
  );
};

export default AllTopupTransactionsChart;
